import type { OrderStatus } from "./types";

/** ອໍເດີ້ທີ່ຍັງບໍ່ຖືກຍົກເລີກ — ແກ້ຂໍ້ມູນລູກຄ້າ/ຂົນສົ່ງໄດ້ */
export function canEditOrderDetails(status: OrderStatus): boolean {
  return status !== "cancelled";
}
